// Import Packages
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";

// Import Material UI
import { Button, Grid, Tooltip } from '@material-ui/core';
import { Edit } from "@material-ui/icons";
import Brightness1Icon from "@material-ui/icons/Brightness1"

// Import Icons
import connectIcon from '../../../../assets/icons/configurationIcons/connect.svg';
import disconnectIcon from '../../../../assets/icons/configurationIcons/disconnect.svg';
import selectDeleteIcon from '../../../../assets/icons/configurationIcons/trash-box.svg'
import selecteditIcon from '../../../../assets/icons/configurationIcons/edit-wheel.svg'
import configureKeyIcon from "../../../../assets/icons/configurationIcons/configure-key.svg";
import customiseViewIcon from "../../../../assets/icons/configurationIcons/customise-view.svg";
import filterIcon from "../../../../assets/icons/configurationIcons/filter.svg";
import emptyPageIcon from "../../../../assets/icons/configurationIcons/empty-page.svg";
import defaultIcon from "../../../../assets/icons/configurationIcons/default-icon.svg";

// Import Pages
import DataTable from "../../../../components/DataTable/DataTable";
import DataTableLoader from "../../../../components/ContentLoader/DataTableLoader";
import Search from "../../../../components/Search/Search";
import CustomizeView from "../../../../components/DataTable/CustomizeView/CustomizeView";
import Filters from "../../../../components/DataTable/Filters/Filters";
import DeleteConfirm from '../../../../components/DataTable/DeleteConfirm';
import { alertState, rolePermission } from '../../../../recoil-store/recoil-state';
import ChooseApplication from '../chooseApplication/ChooseApplication';
import AppCredentialModal from "../appCredentialModal/AppCredentialModal";
import NewAccordion from '../../../../components/Accordion/NewAccordion';

// Import Services
import appService from "../../../../services/ApplicationService/ApplicationService";

// Import Css
import './ListAppCredential.css';

let deletedAppCredentials = [];
let setSelectedAutomRow;
const ListAppCredentials = () => {
    const { t } = useTranslation();
    const [selectedApp, setSelectedApp] = useState({});
    const [openChooseApp, setOpenChooseApp] = useState(false);
    const [openAppCredential, setOpenAppCredential] = useState(false);
    const [isUpdateCredential, setIsUpdateCredential] = useState(false);
    const [appCredentialId, setAppCredentialId] = useState('');

    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState('');
    const [loading, setLoading] = useState(false); // default true
    const [searchData, setSearchData] = useState([])
    const [customColumn, setCustomColumn] = useState([])
    const [customItemColumn, setCustomItemColumn] = useState([])
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [dynamicStyle, setDynamicStyle] = useState({});
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [lastDates, setLastDates] = useState([]);
    const setAlert = useSetRecoilState(alertState);
    const permissions = useRecoilValue(rolePermission);
    const label = 'CONTENT.APP-CREDENTIAL.';
    const nameInfo = useRef(null)

    useEffect(() => {
        fetchData().then(r => r);
    }, [refresh]);

    useEffect(() => {
        if (!openAppCredential && !openChooseApp) {
            setIsUpdateCredential(false)
        }
    }, [openAppCredential, openChooseApp]);

    function getLatestDate(dates) {
        if (dates.length === 0) {
            return null; // Eğer dizi boşsa, null döner.
        }

        let latestDate = new Date(dates[0]); // İlk tarihi en yeni olarak kabul ediyoruz başlangıçta.

        dates.forEach(dateStr => {
            const currentDate = new Date(dateStr);
            if (currentDate > latestDate) { // Eğer mevcut tarih, şu ana kadar bulunan en yeni tarihten daha yeni ise
                latestDate = currentDate; // En yeni tarihi güncelle.
            }
        });

        return latestDate.toISOString(); // En yeni tarihi ISO string formatında döndür.
    }

    async function fetchData() {
        setLoading(true);
        const response = await appService.getAppCredentialList();
        if (response?.status) {
            if (Array.isArray(response?.data) && response?.data.length) {
                let groupedByAppName = {};
                let groupedCreatedTime = {}
                const newData = response.data.forEach(item => {
                    const appName = item.application_name;

                    if (!groupedByAppName[appName]) {
                        groupedByAppName[appName] = [];
                        groupedCreatedTime[appName] = [];
                    }
                    groupedByAppName[appName].push(item);
                    groupedCreatedTime[appName].push(item.updated_at);
                });
                let createdTimes = Object.values(groupedCreatedTime);
                createdTimes = createdTimes.map(times => {
                    const lastDate = getLatestDate(times)
                    return lastDate
                })
                let resultArray = Object.values(groupedByAppName);
                setLastDates(createdTimes);
                setData(response.data);
                setSearchData(resultArray)
                // setData(response.data);
                // setSearchData(response.data)

            } else {
                setData([]);
                setSearchData([])
            }
        }
        setLoading(false);
    }

    // const handleRowsDelete = useCallback((rowsDeleted, dataArray, setSelectedRows) => {
    //     if (permissions?.data.includes('CUSTOMAUTOMS_DELETE')) {
    //         setOpenDelete(true);
    //         deletedAppCredentials = [];
    //         for (let i of rowsDeleted.data) {
    //             deletedAppCredentials.push(searchData[i.dataIndex].id);
    //         }
    //         setSelectedAutomRow = setSelectedRows;
    //     } else {
    //         setAlert(alert => ({
    //             ...alert,
    //             show: true,
    //             message: t("MESSAGES.AUTH-PAGES.RESET-PAGE.HASH-IS-NOT-PROVIDED"),
    //             severity: 'error'
    //         }))
    //     }
    // }, [openDelete, permissions, searchData]);
    const handleRowsDelete = useCallback((id) => {
        if (permissions?.data.includes('CUSTOMAUTOMS_DELETE')) {
            setOpenDelete(true);
            deletedAppCredentials = [];
            deletedAppCredentials.push(id);
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTH-PAGES.RESET-PAGE.HASH-IS-NOT-PROVIDED"),
                severity: 'error'
            }))
        }
    }, [openDelete, permissions, searchData]);

    function handleOpen(open, setState) {
        setState(!open);
    }

    const deleteAppCredentials = async () => {
        let ids = deletedAppCredentials;
        setLoadingDelete(true);
        const response = await appService.deleteAppCredentials(ids);
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(`MESSAGES.APP-CREDENTIAL.${response.message}`),
                severity: response.status ? 'success' : 'error'
            }))
            if (response.status) {
                // setSelectedAutomRow([]);
                fetchData();
            }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setLoadingDelete(false);
    };

    const showUpdatePage = (appCredential) => {
        setSelectedApp({
            id: appCredential.application_id,
            name: appCredential.application_name,
            image_path: appCredential.image_path,
            connector_fields: appCredential.connector_fields
        });
        setAppCredentialId(appCredential.id);
        // setIsUpdateCredential(false)
        setOpenAppCredential(true);
    }
    function convertDateFormat(inputDate) {
        const date = new Date(inputDate);
        try {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

            const optionsTime = { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
            const formattedTime = new Intl.DateTimeFormat('en-US', optionsTime).format(date);

            return `${formattedTime}; ${formattedDate}`;
        } catch (e) {
            return ""
        }
    }
    const quickAddCredential = (appName) => {
        const fetchData = async () => {
            const result = await appService.getApplications({
                connector_fields: "NOT NULL"
            })

            if (result.code === 200) {
                const selectedApp = result.data.find((item) => item?.name === appName)
                setAppCredentialId("")
                setSelectedApp(selectedApp);
                setOpenAppCredential(true)
            }
        }
        if (appName) {
            fetchData().then(r => r);
        }
    }

    useEffect(() => {
        const headerColumn = [
            {
                id: 0,
                name: "image_path",
                label: "",
                // label: t(label + 'APPLICATION'),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            return <div className='app-image-container'>
                                <Tooltip title={searchData[dataIndex][0].application_name} placement="top">
                                    <img draggable={false} className='app-image' src={searchData[dataIndex][0].image_path} />
                                </Tooltip >
                            </div>
                        }
                    },
                }
            },
            {
                id: 1,
                name: "application_name",
                label: t(label + 'APPLICATION-NAME'),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            const updateTime = convertDateFormat(searchData[dataIndex][0].updated_at)
                            return <p className='info-text'>{searchData[dataIndex][0].application_name}</p>;
                        }
                    },
                }
            },
            {
                id: 2,
                name: "credentials",
                label: t(label + 'CREDENTIALS'),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            return <div className='credentials-count-box'><p className='credentials-count'>{searchData[dataIndex].length}</p></div>;
                        }
                    },
                },
            },
            {
                id: 3,
                name: "updated_at",
                label: t(label + 'UPDATED'),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex] && lastDates.length) {
                            const updateTime = convertDateFormat(lastDates[dataIndex])
                            return <p className='info-text'>{updateTime}</p>;
                        }
                    },
                },
            },
        ]
        const column = [
            {
                id: 0,
                name: "name",
                label: t(label + "NAME"),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex, item) => {
                        if (item) {
                            return (
                                <>
                                    <h5 id={`credential-name-header-${item.id}`} ref={nameInfo} className='bold-info-text overflow-text'>
                                        {item.name}
                                    </h5>
                                    {/* <Tooltip title={item.name} placement="top">
                                        <h5 id={`dot_${item.id}`} className='long-text-show bold-info-text' style={dynamicStyle}>...</h5>
                                    </Tooltip> */}
                                </>
                            )
                        }
                    }
                },
            },
            {
                id: 1,
                name: "owner",
                label: t(label + 'OWNER'),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex, item) => {
                        if (item) {
                            return <h5 className='bold-info-text'>{item.user?.first_name ? ' ' + item.user?.first_name : 'administrator'}</h5>;
                        }
                    },
                },
            },
            {
                id: 2,
                name: "auth_type",
                label: t(label + 'AUTHENTICAITON-TYPE'),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex, item) => {
                        if (item) {
                            return <div className='auth-type-column'>{item.credential_type.replace(/_/g, " ").split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}</div>;
                        }
                    },
                },
            },
            {
                id: 3,
                name: "created_at",
                label: t(label + 'CREATED'),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex, item) => {
                        if (item) {
                            const createTime = convertDateFormat(item.created_at)
                            return <p className='info-text'>{createTime}</p>;
                        }
                    },
                }
            },


            {
                id: 11,
                name: "actions",
                label: "",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex, item) => {
                        // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                        return (
                            <div className='credential-option-container'>
                                <Tooltip title={t(label + `${item.status ? "DISCONNECT" : "CONNECT"}`)} placement="top">
                                    <img className='credential-option-img app-connect-button' src={item.status ? disconnectIcon : connectIcon} />
                                </Tooltip>
                                <Tooltip title={t(label + 'DELETE-CREDENTIAL')} placement="top">
                                    <img onClick={() => handleRowsDelete(item.id)} className='credential-option-img' src={selectDeleteIcon} />
                                </Tooltip>
                                <Tooltip title={t(label + 'EDIT-CREDENTIAL')} placement="top">
                                    <img onClick={() => showUpdatePage(item)} className='credential-option-img' src={selecteditIcon} />
                                </Tooltip>
                            </div>
                        );
                    },
                },
            },
            {
                id: 4,
                name: "default",
                label: "",
                // label: t(label + 'APPLICATION'),
                options: {
                    filter: false, sort: false,
                    customBodyRenderLite: (dataIndex, item) => {
                        if (item && item.is_default) {
                            return <Tooltip title={t(label + 'DEFAULT-CREDENTIAL')} placement="top"><div className='default-show-box'>
                                <img src={defaultIcon} />
                            </div></Tooltip>
                        }
                    },
                }
            },
        ]
        setCustomColumn(headerColumn)
        setCustomItemColumn(column)
    }, [searchData, t, setCustomColumn])

    const setApplication = (app) => {
        setSelectedApp(app);
        setOpenAppCredential(true);
    }

    const cancel = () => {
        setOpenAppCredential(false)
    }

    const changeApp = () => {
        setOpenAppCredential(false);
        setOpenChooseApp(true);
    }

    const afterSave = (t) => {
        setRefresh(t);
        setOpenAppCredential(false);
    }

    return (
        <div id="credential-container" className='data-container'>
            <div className='header-div'>
                <h3 className='header-title'>{t(label + "APPLICATION-CREDENTIALS")}</h3>
                <Button onClick={() => {
                    setOpenChooseApp(true);
                    setAppCredentialId('')
                    setIsUpdateCredential(true)
                }} className="new-app-button"><img className='configure-key-icon' src={configureKeyIcon} />{t(label + "CONFIGURE-NEW-APP")}</Button>
            </div>
            <Search data={data} setSearchData={setSearchData} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}
                searchKey={['name', 'owner', 'application_name']} grandArray={true}>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    {/* <Link style={{ textDecoration: 'none' }} to="new">
                        <Button className="searchbar-button">{t('CONTENT.USER.CREATE-USER')}</Button>
                    </Link> */}
                    {/* <Button onClick={() => {
                        setOpenChooseApp(true);
                        setAppCredentialId('')
                    }} className="searchbar-button">New Credential</Button> */}
                    <Button className="searchbar-button application-searchbar-button"
                        onClick={() => handleOpen(openCustomizeView, setOpenCustomizeView)}>
                        <img className='configure-key-icon' src={customiseViewIcon} />{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</Button>
                    {/* <Button className="searchbar-button application-searchbar-button"
                        onClick={() => handleOpen(openFilters, setOpenFilters)}>
                        <img className='configure-key-icon' src={filterIcon} />{t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}</Button> */}
                </Grid>
            </Search>
            {loading ? <DataTableLoader /> :
                <div className='table-container'>
                    {!searchData.length &&
                        <div className='empty-page-info-container'>
                            <img src={emptyPageIcon} />
                            <p className='info-text'>{t(label + 'EMPTY-CREDENTIAL')}</p>
                        </div>
                    }
                    {searchData && searchData.length ? searchData.map((data, index) => {
                        return <NewAccordion
                            data-test="automlist-datatable"
                            customColumns={customColumn}
                            customItemColumns={customItemColumn}
                            quickAddCredential={quickAddCredential}
                            onRowsDelete={handleRowsDelete}
                            selectableRows="multiple"
                            data={data ? data : []}
                            index={index}
                            title={t("CONTENT.AUTOMS-LIST.AUTOM-LIST")}
                            loading={loading}
                            loadingDelete={loadingDelete}
                            selectedRowMessage={label + "SELECTED-MESSAGE"}
                            perPageMessage={label + "PER-PAGE-MESSAGE"}
                            isAccordion={true}
                            infoIcon={true}
                            label={label}
                        />
                    }) : ""}

                </div>
            }
            {/* {
                loading ? <DataTableLoader /> :
                    <Grid
                        item
                        sm={12}
                        data-test="listautom-page"
                    >
                        <DataTable
                            data-test="automlist-datatable"
                            customColumns={customColumn}
                            onRowsDelete={handleRowsDelete}
                            selectableRows="multiple"
                            data={searchData ? searchData : []}
                            title={t("CONTENT.AUTOMS-LIST.AUTOM-LIST")}
                            loading={loading}
                            loadingDelete={loadingDelete}
                            selectedRowMessage={label + "SELECTED-MESSAGE"}
                            perPageMessage={label + "PER-PAGE-MESSAGE"}
                        />

                    </Grid>
            } */}
            {openChooseApp &&
                <ChooseApplication setSelectedApp={setApplication} setOpen={setOpenChooseApp} setIsUpdateCredential={setIsUpdateCredential} />}

            {openAppCredential &&
                <AppCredentialModal selectedApp={selectedApp} setSelectedApp={setSelectedApp}
                    changeApp={changeApp}
                    setIsUpdateCredential={setIsUpdateCredential}
                    setOpen={setOpenAppCredential} open={openChooseApp} afterSave={afterSave}
                    cancel={cancel} appCredentialId={appCredentialId}
                    isUpdateCredential={isUpdateCredential}
                    data={data}
                />}

            {openDelete &&
                <DeleteConfirm setOpenDelete={setOpenDelete} message={t(label + "DELETE-WARNING")}
                    deleteFunc={deleteAppCredentials} />}
            {openCustomizeView && <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn}
                setCustomColumn={setCustomColumn} />}
            {openFilters &&
                <Filters setOpen={setOpenFilters} customColumn={customColumn}
                    setCustomColumn={setCustomColumn} />}
        </div>
    );
};

export default ListAppCredentials;
